import {ImageModel} from '@mintdata/mint-components/components/image/model/ImageModel';
import {BaseFieldConverter} from '@mintdata/mint-kit/impl/properties/converters/BaseFieldConverter';

export class ImageConverter extends BaseFieldConverter<ImageModel>
{
}
